/* eslint-disable max-lines*/
import { makeStyles } from '@material-ui/core';
import { Form, Formik } from 'formik';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { PropTypes } from 'prop-types';
import LanguageContext from '../../../contexts/languageContext';
import MessagesContext from '../../../contexts/messagesContext';
import { getNamespace } from '../../../utils/storage';
import { SubmitButton } from '../../UI';
import { CloseIcon } from '../../UI/Images/Icons';
import { editForm } from '../../../redux/DynamicForms/DynamicFormsAction';
import ClinicAutocomplete from '../../UI/inputs/ClinicAutocomplete';

const styles = makeStyles({
    submitBtnContainer: (props) => ({
        display: 'flex',
        justifyContent: 'flex-end',
        position: 'absolute',
        bottom: '17px',
        left: props.rtl ? '10px' : 'auto',
        right: props.rtl ? 'auto' : '10px',
        margin: '0 10px'
    }),
    tag: {
        borderRadius: '4px',
        backgroundColor: '#e8ecf2',
        color: '#232733',
        fontFamily: 'inherit',
        fontSize: '13px',
        '& svg': {
            margin: '0px 3px !important'
        }
    },
    clinicWrapper: {
        marginBottom: '50px'
    }
});
const AddClinic = ({ handleClose, clinics, formName }) => {
    const { messages } = useContext(MessagesContext);
    const { lang } = useContext(LanguageContext);
    const classes = styles({ rtl: lang === 'fa' });
    const namespace = getNamespace();
    const polyclinic = useSelector((state) =>
        state?.user?.polyclinics?.find((item) => item.id === namespace)
    );
    const dispatch = useDispatch();
    const selectedClinic = clinics?.map((item) => item.id);
    const [options, setOptions] = useState([]);
    useEffect(() => {
        if (polyclinic?.clinics?.length) {
            setOptions(polyclinic?.clinics?.map((item) => ({ id: item.id, name: item.name })));
        }
    }, [polyclinic]);

    // Clinics that the form has access to but are not in the user's clinic list
    // const formClinics = clinics
    //     ?.filter((clinic) => !options?.find((option) => clinic.id === option.id))
    //     ?.map((item) => item.id);

    return (
        <Formik
            enableReinitialize
            initialValues={{ clinics: selectedClinic || [] }}
            validationSchema={Yup.object({
                clinics: Yup.array().required(messages.validations.required)
            })}
            onSubmit={async (values, { setSubmitting }) => {
                // const value = { clinics: [...formClinics, ...values.clinics] };
                setSubmitting(true);
                const response = await dispatch(editForm(formName, values));
                setSubmitting(false);
                if (response?.status === 201 || response?.status === 200) {
                    handleClose();
                }
            }}
        >
            {({ isSubmitting, values, setFieldValue }) => (
                <Form>
                    <div className={classes.clinicWrapper}>
                        <ClinicAutocomplete
                            width="100%"
                            options={options}
                            label={messages.clinic}
                            name="clinics"
                            value={values.clinics}
                            customIcon={null}
                            setValue={(value) => {
                                setFieldValue('clinics', value);
                            }}
                            customClasses={classes}
                            disableEndAdornment
                            noOptionsText={messages.noClinicFound}
                            chipProps={{
                                deleteIcon: <CloseIcon width="19px" height="19px" color="#545e66" />
                            }}
                        />
                    </div>
                    <div className={classes.submitBtnContainer}>
                        <SubmitButton
                            data-testid="submitBtn"
                            isSubmitting={isSubmitting}
                            submitText={messages.saveChanges}
                        />
                    </div>
                </Form>
            )}
        </Formik>
    );
};
AddClinic.propTypes = {
    handleClose: PropTypes.func,
    clinics: PropTypes.array,
    formName: PropTypes.string
};

export default AddClinic;
